import React from 'react'
import {Segment } from 'semantic-ui-react'

class Loader extends React.Component{



    render(){
        return <Segment loading={this.props.loading} className='resetBackground resetCorners resetBorders' >
        </Segment>
    }
}
export default Loader


// WEBPACK FOOTER //
// ./src/components/Sistema/Loader.js